import { isEmpty } from 'lodash';
import { store } from '~/store';

function _loop(navigations, url) {
  const node = navigations
    .map((navigation) => {
      if (navigation.rotamenu === url) return navigation.help.toString();
      if (!isEmpty(navigation.submenus)) {
        const desiredNode = _loop(navigation.submenus, url);
        if (desiredNode) return desiredNode;
      }

      return false;
    })
    .filter((event) => event.length)
    .toString();

  return node;
}

export function searchHelperPropertyInNavigationMenu() {
  const { navigations } = store.getState().drawer;

  const url = window.location.pathname;

  if (url === '/dashboard') return false;

  return _loop(navigations, url) === 'true';
}

export function getURLHelper() {
  const { url_help, perf_tipo } = store.getState().user.profile;
  const url = window.location.pathname;

  switch (Number(perf_tipo)) {
    case 1:
    default:
      return `${url_help}${url}/unidata.pdf`;
    case 2:
      return `${url_help}${url}/gfe.pdf`;
    case 3:
      return `${url_help}${url}/gfo.pdf`;
    case 4:
      return `${url_help}${url}/gfu.pdf`;
    case 5:
      return `${url_help}${url}/gppe.pdf`;
    case 6:
      return `${url_help}${url}/gpp.pdf`;
    case 7:
      return `${url_help}${url}/frentista.pdf`;
    case 8:
      return `${url_help}${url}/gppmp.pdf`;
  }
}
